import React, { memo } from 'react';
import styles from './button-back.module.scss';
import cn from 'classnames'
import { Animate } from '../../animation/animation';

interface ButtonBackProps {
	active: boolean
	onClick: (event:React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
	onMouseEnter?: () => void;
  onMouseOut?: () => void; 
	mode?: 'default' | 'static' | 'phone-form'
  disabled?: boolean
	customStyles?: Record<string, string>
}

export const ButtonBack = memo(({ onClick, active, mode='default', disabled = false, customStyles, onMouseEnter, onMouseOut }:ButtonBackProps) => {
	return (
    <Animate when={active} duration={400} animation={'go_right_with_fade'}>
			<button
				type="button"
        disabled={disabled} 
        onClick={onClick} 
        className={cn(styles[mode])}
				style={customStyles}
				onPointerEnter={onMouseEnter}
      	onPointerOut={onMouseOut}
      />
		</Animate>
	);
});